import React from 'react';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { WidgetRow, WidgetFooter, WidgetEmpty, Pill, useGoTo } from './common';

// Things I raised that sit in someone else's queue. Age drives the tone so
// the long waits stand out.
const toneForDays = (days) => (days >= 5 ? 'error' : days >= 2 ? 'pending' : 'neutral');

const WaitingOnOthersWidget = ({ data }) => {
  const goTo = useGoTo();
  const items = data.items || [];
  return (
    <>
      {items.length === 0 && <WidgetEmpty>Nothing of yours is waiting on someone else.</WidgetEmpty>}
      {items.map((i) => (
        <WidgetRow
          key={i.key}
          icon={faClock}
          tone="neutral"
          title={i.title}
          subtitle={[i.kind_label, i.with_label].filter(Boolean).join(' · ')}
          right={<Pill tone={toneForDays(i.age_days)}>{i.age_label}</Pill>}
          onClick={i.url ? () => goTo(i.url) : undefined}
        />
      ))}
      {data.url && <WidgetFooter label="Open notifications" url={data.url} />}
    </>
  );
};

export default WaitingOnOthersWidget;
